export class WordTypeScoreMO {
	public verbScore: number;
	public nounScore: number;
	public prepScore: number;
	public wasteScore: number;
	public ad_Score: number;
	public verbGraphScore: number;
	public nounGraphScore: number;
	public prepGraphScore: number;
	public wasteGraphScore: number;
	public ad_GraphScore: number;
	public verbRating: number;
	public nounRating: number;
	public prepRating: number;
	public wasteRating: number;
	public ad_Rating: number;
	public average: number;

	constructor(
		verbScore = 0,
		nounScore = 0,
		prepScore = 0,
		wasteScore = 0,
		ad_Score = 0,
		average = 0,
		verbRating = 0,
		nounRating = 0,
		prepRating = 0,
		wasteRating = 0,
		ad_Rating = 0,
		verbGraphScore = 0,
		nounGraphScore = 0,
		prepGraphScore = 0,
		wasteGraphScore = 0,
		ad_GraphScore = 0,
	) {
		this.nounScore = nounScore;
		this.prepScore = prepScore;
		this.verbScore = verbScore;
		this.wasteScore = wasteScore;
		this.ad_Score = ad_Score;
		this.average = average;
		this.verbRating = verbRating;
		this.nounRating = nounRating;
		this.prepRating = prepRating;
		this.wasteRating = wasteRating;
		this.ad_Rating = ad_Rating;
		this.nounGraphScore = nounGraphScore;
		this.prepGraphScore = prepGraphScore;
		this.verbGraphScore = verbGraphScore;
		this.wasteGraphScore = wasteGraphScore;
		this.ad_GraphScore = ad_GraphScore;
	}

	public reset() {
		this.nounScore = 0;
		this.prepScore = 0;
		this.verbScore = 0;
		this.wasteScore = 0;
		this.ad_Score = 0;
		this.verbRating = 0;
		this.nounRating = 0;
		this.prepRating = 0;
		this.wasteRating = 0;
		this.ad_Rating = 0;
		this.nounGraphScore = 0;
		this.prepGraphScore = 0;
		this.verbGraphScore = 0;
		this.wasteGraphScore = 0;
		this.ad_GraphScore = 0;
	}
}
